import { ServerTypeHelper, LayerFolderHelper } from '../helpers';

const osmLayers = [
  {
    wmsName: '',
    title: 'Vias',
    url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
    visibility: false,
    queryable: false,
    serverType: ServerTypeHelper.OSM,
    folder: LayerFolderHelper.OSM,
    folderSequence: LayerFolderHelper.OSM,
    theme: 'light'
  },
  {
    wmsName: '',
    title: 'Mapa escuro',
    url: 'https://{a-c}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',
    visibility: false,
    queryable: false,
    serverType: ServerTypeHelper.OSM,
    folder: LayerFolderHelper.OSM,
    folderSequence: LayerFolderHelper.OSM,
    theme: 'dark'
  },
   {
    wmsName: '',
    title: 'Mapa global claro',
    url: 'https://{a-c}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
    visibility: false,
    queryable: false,
    serverType: ServerTypeHelper.OSM,
    folder: LayerFolderHelper.OSM,
    folderSequence: LayerFolderHelper.OSM,
    theme: 'light'
  },
];


export default osmLayers;